module.exports = __webpack_public_path__ + "front/img/31.119c6f5a.png";